/* unplugin-vue-components disabled */import { render } from "./tongji.vue?vue&type=template&id=5084b43a&scoped=true"
import script from "./tongji.vue?vue&type=script&lang=js"
export * from "./tongji.vue?vue&type=script&lang=js"

import "./tongji.vue?vue&type=style&index=0&id=5084b43a&scoped=true&lang=css"

import exportComponent from "/Users/admin/Desktop/project/klb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5084b43a"]])

export default __exports__